/**
 * @typedef {{ content: React.ReactNode, className?: string }} Props
 * @typedef {{ open: boolean }} State
 */

import React from 'react';

/** @extends {React.Component<Props, State>} */
export default class HoverPopover extends React.Component {
	/** @param {Props} props */
	constructor(props) {
		super(props);

		/** @type {State} */
		this.state = {
			open: false,
		};

		/** @type {React.RefObject<HTMLDivElement>} */
		this.ref = React.createRef();

		this._handleMouseEnter = this._handleMouseEnter.bind(this);
		this._handleMouseLeave = this._handleMouseLeave.bind(this);
	}

	_handleMouseEnter() {
		this.setState({ open: true });
	}

	_handleMouseLeave() {
		this.setState({ open: false });
	}

	/**
	 * @returns {JSX.Element | null}
	 */
	render() {
		if (!this.props.content) {
			return null;
		}

		/** @type {string} */
		const rootClass = this.props.className ?? 'relative inline-block ml-1';

		return (
			<div
				className={rootClass}
				onMouseEnter={this._handleMouseEnter}
				onMouseLeave={this._handleMouseLeave}
				ref={this.ref}
			>
				<button
					aria-label="info"
					className="flex items-center justify-center w-4 h-4 text-[10px] border rounded-full cursor-default hover:bg-gray-100 select-none"
					type="button"
				>
					{'i'}
				</button>

				{this.state.open ? (
					<div className="absolute text-left left-5 top-0 z-50 w-56 p-2 text-xs font-normal bg-white border rounded shadow-lg">
						{this.props.content}
					</div>
				) : null}
			</div>
		);
	}
}
